module.exports = __webpack_public_path__ + "img/Arch-Smooth-min.4901dff4.png";